// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "545") return "libraries/vendors/99cbd4d8/index.js";
  // return url for filenames based on template
  return "" + chunkId + ".javascript"
}